import React from 'react';
import FeaturedProductsListsTable from '../components/FeaturedProductsListsTable';

export function FeaturedProductsLists() {
  return <FeaturedProductsListsTable />;
}
